// import { Token } from '@angular/compiler';
import { Component,
         OnInit,
         AfterViewInit,
         OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

// import { CookieService } from 'ngx-cookie';
import { filter, map } from 'rxjs';

import { TokenService,
         AuthService } from './_core';

// import { environment } from './environments';
// environment


// import * as jwt from 'jsonwebtoken';

import { WindowService } from 'src/app/_core/index'


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, AfterViewInit {

  title = 'lcp'
  token$: any

  GoogleAuth: any

  constructor(
    // private cookieService: CookieService,
    private authService: AuthService,
    // private route: ActivatedRoute,
    // private routerService: RouterService,
    private windowService: WindowService,
    private router: Router,
    private titleService: Title,
    private tokenService: TokenService
  ) {}


  ngOnInit() {
    // this.loadPaypal()

    // let options = {  }
    // let cook = this.getCookie('lcp_user')
    this.listenToStorage()

    this.authService.populateAuth()

    this.listenToTitle()
  }

  // adds paypal script to <head>
  // loadPaypal() {
  //   if (!environment.paypal_client_id) console.log('ERR: NO PAYPAL ID IN ENVIRONMENT...')

  //   let node = document.createElement('script'); // creates the script tag
  //   // <script src="https://www.paypal.com/sdk/js?currency=USD&disable-funding=credit&client-id=ATSK4W0ZTcygJjkoQqcSzfNEua6zS3itj8j49d34DruvJE3wexHmmHVmm0yeLNQqttmfgKd7_3bdkOxR"></script>   <!-- OAK_PARK LIVE -->

  //   let url = 'https://www.paypal.com/sdk/js?currency=USD&disable-funding=credit&client-id='; // sets the source (insert url in between quotes)
  //   url += environment.paypal_client_id
  //   node.src = url
  //   node.type = 'text/javascript'; // set the script type
  //   node.async = true; // makes script run asynchronously
  //   node.charset = 'utf-8';
  //   // append to head of document
  //   document.getElementsByTagName('head')[0].appendChild(node); 
  //   console.log('LOADED PAYPAL', node)
  // }

  ngAfterViewInit() {
    document.addEventListener('scroll', (e) => this.onScroll(e))
  }

  ngOnDestroy() {
    // if (this.route$) this.route$.unsubscribe()
  }

  // getAccessToken(): void {
  //   this.authService.getAccessToken(GoogleLoginProvider.PROVIDER_ID).then(accessToken => this.accessToken = accessToken);
  // }

  listenToStorage() {
    // console.log('(listening to local storage)')
    window.addEventListener('storage', function(event){
      // console.log('storage evt:', event)
      if (event.storageArea === localStorage) {
        // It's local storage
        // console.log('localStorage', event)
      }
    }, false);
  }

  // getCookie(key: string){
  //   // console.log('getCookie', key, this.cookieService.get(key), this.cookieService.getObject(key))
  //   return this.cookieService.get(key)
  // }

  // getCookieObject(key: string){
  //   // console.log('cookie', key, this.cookieService.get(key), this.cookieService.getObject(key))
  //   return this.cookieService.getObject(key)
  // }

  // putCookieObject(key: string, obj: any, options?) {
  //   this.cookieService.putObject(key, obj, options)
  // }

  // https://dev.to/brandontroberts/setting-page-titles-natively-with-the-angular-router-393j
  listenToTitle() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['title']) {
            routeTitle = route!.snapshot.data['title'];
          }
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (title) this.titleService.setTitle(`${title} | lcp`);
      });
  }

  onScroll(e: any) {
    // console.log('scrolling')
    this.windowService.updateScrollContainers()
  }
 
  initWindowScrollContainer() {
    this.windowService.updateScrollElement('window', window)
  }

}
